import React from "react";
import { Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const FabButton = ({ onClick }) => (
    <Fab
        color="secondary"
        aria-label="add"
        className="fab"
        onClick={onClick}
        data-cy="fab-button"
    >
        <AddIcon />
    </Fab>
);

export default FabButton;
